import LayoutNavigationHelper from './layout-navigation-helper';
import LazyHelper from '../helpers/lazy-helper';

class DesktopNavigation {
  constructor(container) {
    this.consts = {
      navIdAttr: 'data-nav-id',
      desktopNavigationScreenWidth: 967
    };

    this.container = container;
    this.isInitialized = false;
    this.loadDesktopNavigationElement = null;
    this.init(container);
  }

  async init() {
    if (DeviceHelper.isMobilebrowser()
      && screen.width < this.consts.desktopNavigationScreenWidth) {
      console.log('Mobile device detected. Desktop navigation not loaded.');

      return;
    }

    const loadDesktopNavigationQuery = document.getElementsByClassName('js-load-desktop-navigation');
    if (loadDesktopNavigationQuery.length > 0) {
      this.loadDesktopNavigationElement = loadDesktopNavigationQuery[0];
    }

    this.navigationUL = this.container.querySelector('ul.nav');

    DomHelper.addClass('megamenu-nav', this.navigationUL);

    this.layouts = new Map();
    this.hasOpenLayout = false;
    this.levelTwoNavigations = new Map();
    this.loadLinks();

    if (!this.isInitialized) {
      await this.loadNavigationFromOtherPage();
    }

    if (!this.loadDesktopNavigationElement || this.isInitialized == true) {
      this.attachEvents();
      this.levelTwoNavigations.clear();
    }
  }

  async loadNavigationFromOtherPage() {
    if (this.loadDesktopNavigationElement) {
      const menusWithArrow = document.querySelectorAll('.main-nav .icon-arrow-down-small');
      if (menusWithArrow.length > 0) {
        menusWithArrow.forEach((menu) => {
          menu.parentElement.addEventListener('click', async (ev) => {
            if (this.isInitialized) {
              return;
            }

            const targetMenuInnerText = ev.target.closest('.main-nav').querySelector('a').innerText;

            const navigationData = await LayoutNavigationHelper.getNavigationData(this.loadDesktopNavigationElement);
            if (navigationData) {
              const navDiv = document.getElementsByClassName('navWrapper')[0];

              navigationData.forEach(item => {
                var navigationlayout = navDiv.querySelector(`.navItemLayout[data-nav-id="${item.id}"]`);
                var navDropdown = navigationlayout.querySelector('.container');
                let html = '<i class="close-button"><svg class="icon icon-x "><use xlink:href="#icon-x"></use></svg></i><div class="sf_colsIn navDropdown"><div class="menuLevelTwoLayout"><div class="sf_colsIn menuLevelTwoLeft"><div class="sf_colsIn navLevelTwoLinksContainer"><ul class="navLevelTwo"></ul></div></div><div class="sf_colsIn menuLevelTwoRight">';
                item.dropdownContent?.forEach(dropdown => {
                  if (dropdown?.htmlContent) {
                    html += `<div class="navLevelTwoLayout">${dropdown.url ? `<div class="navLevelTwoLink"><div><a href="${dropdown.url}">${dropdown.title ?? ''}</a></div></div>` : ''} ${dropdown.htmlContent}</div>`;
                  }
                });

                html += '</div></div></div>';
                navDropdown.innerHTML = html;

                if (item.bottomContent?.htmlContent) {
                  const wrapper = document.createElement('div');
                  wrapper.className = 'sf_colsIn navItemBottomContent';
                  wrapper.innerHTML = item.bottomContent.htmlContent.trim();

                  navDropdown.appendChild(wrapper);
                }
              });

              this.isInitialized = true;
              await this.init();

              document.querySelectorAll('.main-nav > a').forEach((link) => {
                if (link.innerText == targetMenuInnerText) {
                  link.classList += ' clicked-menu';
                }
              });

              document.querySelector('.clicked-menu').click();
            }
          })
        });
      }
    }
  }

  loadLinks() {
    this.layouts.clear();
    var items = Array.prototype.slice.call(this.container.getElementsByClassName('navItemLayout'));
    var homeLinkRendered = false;
    var navigationUL = this.container.querySelector('ul.nav');
    var arrowIcon = IconHelper.getSvgHref('icon-arrow-down-small');

    // generate desktop and mobile main nav parent links
    items.forEach((item) => {
      let navId = item.getAttribute(this.consts.navIdAttr);

      if (!navId) {
        navId = `nav-${item.innerText.toLowerCase()}`;
        item.setAttribute(this.consts.navIdAttr, navId);
      }

      this.layouts.set(navId, item);

      var originalmenuLink = item.querySelector('.navParent ul li:first-child');

      if (!originalmenuLink) {
        return;
      }

      var html = originalmenuLink.outerHTML;

      navigationUL.insertAdjacentHTML('beforeend', html);
      DomHelper.removeElement(originalmenuLink);
      var menuLink = navigationUL.lastElementChild;

      menuLink.setAttribute(this.consts.navIdAttr, navId);

      DomHelper.addClass('main-nav', menuLink);

      if (LayoutNavigationHelper.layoutHasContent(item)) {
        var anchor = menuLink.getElementsByTagName('a')[0];

        if (anchor) {
          anchor.insertAdjacentHTML('beforeend', arrowIcon);
          anchor.addEventListener('click', (ev) => { ev.preventDefault(); });
        }
      } else {
        DomHelper.addClass('link', menuLink);
      }

      if (!homeLinkRendered && DomHelper.hasClass('navHomeItemLayout', item)) {
        DomHelper.addClass('home', menuLink);
        homeLinkRendered = true;
      }

      var navParent = item.getElementsByClassName('navParent')[0];
      DomHelper.removeElement(navParent);
    });
  }

  attachEvents() {
    this.navigationUL.addEventListener('click', (ev) => {
      if (!document.getElementById('navigation-level-two-script')) {
        var ev1 = LazyHelper.addScriptFile('/Frontend-Assembly/SitefinityWebApp/ResourcePackages/Wartsila_One/assets/scripts/megamenu-desktop-navigation-level-two.js', 'navigation-level-two-script', true);
        LazyHelper.addCssFile('/Frontend-Assembly/SitefinityWebApp/ResourcePackages/Wartsila_One/assets/styles/navigation.css', true);
        var layoutItems = this.layouts;
        var levelTwoNavigationItems = this.levelTwoNavigations;
        ev1.onload = function () {
          layoutItems.forEach((value, key, map) => {
            var levelTwo = new window.MegamenuNavigationLevelTwo(value);
            levelTwoNavigationItems.set(key, levelTwo);
          });
        }
      }

      let el = DomHelper.getClickTarget(ev);
      let menuLink = DomHelper.closest(el, '.main-nav', this.navigationUL);

      if (menuLink) {
        var navId = menuLink.getAttribute(this.consts.navIdAttr);
        var layout = this.layouts.get(navId);

        if (LayoutNavigationHelper.layoutHasContent(layout)) {
          this.menuLinkClicked(menuLink);
        }
      }
    });

    document.body.addEventListener('click', (ev) => {
      let el = DomHelper.getClickTarget(ev);

      var navContainer = DomHelper.closest(el, '.nav-container');
      var navDropdown = DomHelper.closest(el, '.navDropdown');

      if (!(navContainer || navDropdown)) {
        this.closeAllLayouts();
      }
    });
  }

  menuLinkClicked(menuLink) {
    var linkWasOpen = this.closeAllLayouts(menuLink);

    if (!linkWasOpen) {
      this.showLayout(menuLink);
    }
  }

  showLayout(menuLink) {
    var navId = menuLink.getAttribute(this.consts.navIdAttr);
    var layout = this.layouts.get(navId);

    if (LayoutNavigationHelper.layoutHasContent(layout)) {
      this.hasOpenLayout = true;
      DomHelper.addClass('open', menuLink);
      DomHelper.addClass('navItemLayoutOpened', layout);
      DomHelper.addClass('mainnav_overlay-visible', document.body);
    }
  }

  closeAllLayouts(menuLink) {
    var linkWasOpen = false;

    this.layouts.forEach((layout, key, map) => {
      DomHelper.removeClass('navItemLayoutOpened', layout);

      if (this.levelTwoNavigations.has(key)) {
        this.levelTwoNavigations.get(key).reset();
      }

    });

    var links = Array.prototype.slice.call(this.navigationUL.getElementsByClassName('open'));
    links.forEach((item) => {
      if (menuLink && menuLink == item) {
        linkWasOpen = true;
      }

      DomHelper.removeClass('open', item);
    });

    DomHelper.removeClass('mainnav_overlay-visible', document.body);
    this.hasOpenLayout = false;

    return linkWasOpen;
  }
}

export default DesktopNavigation;